import { render, staticRenderFns } from "./LabelText.vue?vue&type=template&id=64bd249c&"
import script from "./LabelText.vue?vue&type=script&lang=js&"
export * from "./LabelText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports